exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".uploadPhotoComponent {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/hq/cards/modify-card/upload-photo/upload-photo.component.css
// module id = ../../../../../src/app/hq/cards/modify-card/upload-photo/upload-photo.component.css
// module chunks = main